/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  ComponentType,
  ReactElement,
} from 'react';

import type {
  NextLinkProps,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

import {
  StyledSideButton,
  StyledSideButtonLink,
} from './styled';

export function NextLink({
  Link,
  isDisabled,
  rootProps: {
    payload,
  },
  innerProps,
  children,
}: NextLinkProps<PaginatorPayload>): ReactElement | null {
  if (payload?.isOnePage) {
    return null;
  }

  return (
    <StyledSideButton
      $isNext
    >
      <StyledSideButtonLink
        as={Link as ComponentType<any>}
        {...innerProps}
        isDisabled={isDisabled}
      >
        {children}
      </StyledSideButtonLink>
    </StyledSideButton>
  );
}
